import sortBy from 'lodash/sortBy';
import { DateTime } from 'luxon';
import { useRef } from 'react';

import { ListingStatus } from 'src/generated/graphql';
import type { ClientListingForListingsTab } from 'src/types/graphql-derived';

const defaultSortOrder = [
  ListingStatus.Active,
  ListingStatus.Pending,
  ListingStatus.Draft,
  ListingStatus.Expired,
];

export const useOneTimeSort = (listings: ClientListingForListingsTab[]) => {
  // Calculate the intial sort order and store it. We never update this "useRef"
  // value, this way all future renders retain the same order as the initial render
  const sortOrder = useRef(
    sortBy(
      listings,
      // Items are sorted in ascending order. Lower numbers come first
      (listing) => defaultSortOrder.indexOf(listing.status),
      // Convert to epoch time where newer dates === higher ms. Invert this so newer
      // dates appear first
      (listing) => -DateTime.fromISO(listing.createdDate).toMillis(),
    ).map((listing) => listing.id),
  );

  const sortedListings = sortBy(listings, (listing) =>
    // Any new listings not in the original array will return -1 and sorted last
    sortOrder.current.indexOf(listing.id),
  );
  return sortedListings;
};
